import { Component,Input, OnInit } from '@angular/core';

@Component({
    selector: 'survey-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  @Input() 
  public commentcardStyles: any;
  constructor() { }

  ngOnInit(): void {
    return;
  }

}

